import clsx from "clsx";

const MandatoryLabel: React.FC<{ label: string; className?: string; isMandatory?: boolean; isDisabled?: boolean }> = (
  props,
) => {
  return (
    <span className={clsx(props?.className, props?.isDisabled && "text-[#22222] text-[12px]")}>
      <span className="text-[8px] text-xs 2xl:text-sm">{props?.label}</span>{" "}
      {props?.isMandatory && <span className="text-red-500">*</span>}
    </span>
  );
};
export default MandatoryLabel;
